import React from 'react';
import "../styles/Footer.css";

export const Footer = () => {
    return (
        <footer className="bg-footer position-relative p-5 possition-footer">
            <div>

            </div>
        </footer>
    )
}
